import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CategoryCourseOnlineList from './category_course_online_list';
import CategoryCourseOnlineDetail from './category_course_online_detail';

class CategoryCourseOnline extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <CategoryCourseOnlineList/>;
    }else{
      if(params.id===undefined){
        view = <CategoryCourseOnlineDetail/>;
      }else{
        view = <CategoryCourseOnlineDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

CategoryCourseOnline.contextTypes = {
  router: PropTypes.object
};

export default CategoryCourseOnline;
